var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{class:'icon' + ' ' + _vm.cssClass,attrs:{"viewBox":_vm.viewBox,"width":_vm.width,"height":_vm.height}},[_c('use',_vm._b({},'use',{'xlink:href' : _vm.svgIcons + '#' + _vm.name},false))])])}
var staticRenderFns = []

export { render, staticRenderFns }